module.exports = __webpack_public_path__ + "img/turbo_off.15d7b13a.png";